import React, { useEffect, useState } from 'react';
import WidgetOpeningCarouselBasic from 'modules/shared/widgets/components/widget-opening/components/widget-opening-carousel-basic';
import { CarouselProps } from 'react-multi-carousel';
import { WidgetOpeningDataItem } from 'modules/shared/widgets/interfaces/widgets-data/widget-opening-data.interface';
import SrcSet from '../../../../../components/src-set/src-set';
import getLinkRelByTarget from 'helpers/get-link-rel-by-target';

import './widget-opening-slider.scss';

interface WidgetOpeningSliderProps {
    autoPlay: boolean;
    isMobile: boolean;
    banner: WidgetOpeningDataItem[];
}

const WidgetOpeningSlider: React.FC<WidgetOpeningSliderProps> = ({ autoPlay, banner, isMobile }) => {
    const [WidgetOpeningCarousel, setWidgetOpeningCarousel] = useState<React.ComponentType<CarouselProps>>(() => WidgetOpeningCarouselBasic);
    const numberOfItems = 1;

    useEffect(() => {
        import('react-multi-carousel').then(mod => {
            setWidgetOpeningCarousel(() => mod.default);
        });
    }, []);

    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 0 },
            items: numberOfItems
        }
    };

    return (
        <div className="widget-opening__slider">
            <WidgetOpeningCarousel
                responsive={responsive}
                swipeable={isMobile}
                draggable={isMobile}
                slidesToSlide={numberOfItems}
                showDots={true}
                renderDotsOutside={false}
                arrows={false}
                autoPlay={autoPlay}
                infinite={autoPlay}
                className="w-opening-carousel__list"
                itemClass={`w-opening-carousel__list__item w-${numberOfItems}`}
            >
                {banner.map((item, idx) => (
                    <a
                        className="link"
                        key={String(idx)}
                        href={item.url}
                        target={item.target}
                        rel={getLinkRelByTarget(item.target)}
                    >
                        <SrcSet
                            className="image"
                            images={item.modifiedImg}
                            alt={item.alt.trim() || `Obrazek ${idx}`}
                            isMobile={isMobile}
                        />
                    </a>
                ))}
            </WidgetOpeningCarousel>
        </div>
    );
};

export default WidgetOpeningSlider;
